// extracted by mini-css-extract-plugin
module.exports = {"fullPage":"NotFound_fullPage__pjZkU","container":"NotFound_container__qsR_f","textContainer":"NotFound_textContainer__hgql7"};